import { z } from "zod";

export const StayAiInternalSettingsDtoSchema = z.object({
  apiKey: z.string(),
});
export type StayAiInternalSettingsDto = z.infer<
  typeof StayAiInternalSettingsDtoSchema
>;
